import CueSize from '../../../../../State/Stores/Captions/Constants/CueSize';

import * as styles from '../textTrack.css';

const mapCueSizeToClassName = (cueSize: CueSize): string => ({
    [CueSize.L]: styles.cueSizeL,
    [CueSize.M]: styles.cueSizeM,
    [CueSize.S]: styles.cueSizeS,
    [CueSize.XL]: styles.cueSizeXl,
    [CueSize.XS]: styles.cueSizeXs
})[cueSize];

export default mapCueSizeToClassName;